
const KaliaLogo = () => {
    return (
        <div className='w-full flex flex-row justify-start mb-4'>
            <div className='h-8'>
                <img className='w-full h-8 object-contain' src='/Kalia_Logo_Organge.png' />
            </div>
        </div>
    )
}

export default KaliaLogo;